(function () {
  'use strict';

  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  var itemsContainer = drawer.querySelector('[data-cart-drawer-items]');
  var subtotalEl = drawer.querySelector('[data-cart-subtotal]');

  function openDrawer() {
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
  }

  function closeDrawer() {
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
  }

  // Open / close triggers
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-drawer-trigger]')) {
      e.preventDefault();
      openDrawer();
    }
    if (e.target.matches('[data-cart-drawer-close]')) {
      e.preventDefault();
      closeDrawer();
    }
  });

  // Esc closes
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
      closeDrawer();
    }
  });

  // Money formatter — uses Shopify's currency from window.Shopify if available
  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AUD';
    return (cents / 100).toLocaleString('en-AU', { style: 'currency', currency: currency });
  }

  // Safe DOM builder helpers — never use innerHTML with cart data
  function makeEl(tag, className, textContent, attrs) {
    var el = document.createElement(tag);
    if (className) el.className = className;
    if (textContent !== undefined && textContent !== null) el.textContent = textContent;
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        el.setAttribute(k, attrs[k]);
      });
    }
    return el;
  }

  function clearChildren(node) {
    while (node.firstChild) node.removeChild(node.firstChild);
  }

  function buildItem(item) {
    var itemEl = makeEl('div', 'cart-drawer__item', null, {
      'data-cart-item': '',
      'data-line-key': item.key
    });

    if (item.image) {
      var img = makeEl('img', 'cart-drawer__item-image', null, {
        src: item.image,
        alt: item.product_title || ''
      });
      itemEl.appendChild(img);
    }

    var body = makeEl('div', 'cart-drawer__item-body');
    body.appendChild(makeEl('h3', 'cart-drawer__item-title', item.product_title));

    if (item.variant_title && item.variant_title !== 'Default Title') {
      body.appendChild(makeEl('p', 'cart-drawer__item-variant', item.variant_title));
    }

    var qty = makeEl('div', 'cart-drawer__item-qty');
    qty.appendChild(makeEl('button', null, '−', {
      type: 'button',
      'data-qty-decrement': '',
      'aria-label': 'Decrease'
    }));
    var input = makeEl('input', null, null, {
      type: 'number',
      value: String(item.quantity),
      min: '0',
      'data-qty-input': ''
    });
    qty.appendChild(input);
    qty.appendChild(makeEl('button', null, '+', {
      type: 'button',
      'data-qty-increment': '',
      'aria-label': 'Increase'
    }));
    body.appendChild(qty);

    body.appendChild(makeEl('p', 'cart-drawer__item-price', formatMoney(item.final_line_price)));

    itemEl.appendChild(body);

    itemEl.appendChild(makeEl('button', 'cart-drawer__item-remove', '×', {
      type: 'button',
      'data-cart-remove': '',
      'aria-label': 'Remove'
    }));

    return itemEl;
  }

  function renderCart(cart) {
    subtotalEl.textContent = formatMoney(cart.total_price);

    var countEls = document.querySelectorAll('[data-cart-count]');
    countEls.forEach(function (el) { el.textContent = String(cart.item_count); });

    clearChildren(itemsContainer);

    if (cart.item_count === 0) {
      itemsContainer.appendChild(makeEl('p', 'cart-drawer__empty', 'Your cart is empty.'));
      return;
    }

    cart.items.forEach(function (item) {
      itemsContainer.appendChild(buildItem(item));
    });
  }

  function updateLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () { /* swallow — leave UI as-is on transient failure */ });
  }

  // Delegate qty + remove clicks
  itemsContainer.addEventListener('click', function (e) {
    var item = e.target.closest('[data-cart-item]');
    if (!item) return;
    var key = item.getAttribute('data-line-key');
    var input = item.querySelector('[data-qty-input]');

    if (e.target.matches('[data-qty-increment]')) {
      var next = parseInt(input.value, 10) + 1;
      input.value = String(next);
      updateLine(key, next);
    } else if (e.target.matches('[data-qty-decrement]')) {
      var nextDown = Math.max(0, parseInt(input.value, 10) - 1);
      input.value = String(nextDown);
      updateLine(key, nextDown);
    } else if (e.target.matches('[data-cart-remove]')) {
      updateLine(key, 0);
    }
  });

  // Manual qty input change
  itemsContainer.addEventListener('change', function (e) {
    if (e.target.matches('[data-qty-input]')) {
      var item = e.target.closest('[data-cart-item]');
      var key = item.getAttribute('data-line-key');
      var qty = Math.max(0, parseInt(e.target.value, 10) || 0);
      updateLine(key, qty);
    }
  });

  // Listen for custom cart-updated events (product page fires this after ajax-add)
  document.addEventListener('vyra:cart:updated', function (e) {
    if (e.detail && e.detail.cart) renderCart(e.detail.cart);
    openDrawer();
  });
})();
